import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IError } from 'src/app/models/error.model';
import { IProvider } from 'src/app/models/provider.model';
import { setWarningText } from 'src/app/reducers/warning-popup.reducer';
import { ProviderService } from 'src/app/services/provider.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-provider-edit-v2',
  templateUrl: './provider-edit.component.html',
  styleUrls: ['./provider-edit.component.sass']
})
export class ProviderEditComponent implements OnInit {
  providerForm!: FormGroup;
  loading = false;
  providerId: string | null = null;
  isRoot = false;

  readonly professionalCouncils = [
    { value: 'CRO', label: 'CRO' },
    { value: 'CRBM', label: 'CRBM' },
    { value: 'CRF', label: 'CRF' },
    { value: 'CRM', label: 'CRM' },
    { value: 'COREN', label: 'COREN' },
    { value: 'CRBIO', label: 'CRBIO' },
    { value: 'CREFITO', label: 'CREFITO' },
    { value: 'N/A', label: 'N/A' }
  ];

  readonly professions = [
    { value: 'Cirurgião Dentista', label: 'Cirurgião Dentista' },
    { value: 'Biomédico', label: 'Biomédico' },
    { value: 'Farmacêutico', label: 'Farmacêutico' },
    { value: 'Enfermeiro', label: 'Enfermeiro' },
    { value: 'Médico', label: 'Médico' },
    { value: 'Fisioterapeuta', label: 'Fisioterapeuta' },
    { value: 'Biólogo com Especialização em Biologia Saúde Estética', label: 'Biólogo com Especialização em Biologia Saúde Estética' },
    { value: 'Esteticista com Pós-graduação em estética avançada', label: 'Esteticista com Pós-graduação em estética avançada' }
  ];

  constructor(
    private readonly fb: FormBuilder,
    private readonly providerService: ProviderService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly store: Store<{ warningPopup: IError }>,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.isRoot = this.authService.getPermission() === 'ROOT';
    
    this.route.paramMap.subscribe(params => {
      this.providerId = params.get('providerId');
      if (this.providerId) {
        this.loadProvider();
      }
    });
  }

  private buildForm(): void {
    this.providerForm = this.fb.group({
      name: ['', Validators.required],
      professionalCouncil: ['', Validators.required],
      profession: ['', Validators.required],
      professionalRegistration: ['', Validators.required]
    });
  }

  private loadProvider(): void {
    if (!this.providerId) return;
    
    this.loading = true;
    this.providerService.getProviderById(this.providerId)
      .subscribe({
        next: (provider) => {
          this.providerForm.patchValue({
            name: provider.name,
            professionalCouncil: provider.professional_council,
            profession: provider.profession,
            professionalRegistration: provider.professional_registration
          });
          if (!this.isRoot) {
            this.providerForm.disable();
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Erro ao carregar prestador:', error);
          this.loading = false;
        }
      });
  }

  cancel(): void {
    this.router.navigate(['/main/v2/providers']);
  }

  submit(): void {
    if (this.providerForm.invalid) {
      this.providerForm.markAllAsTouched();
      this.store.dispatch(setWarningText('Preencha e valide todos os campos obrigatórios.'));
      return;
    }

    if (!this.providerId) return;

    this.loading = true;
    const formValue = this.providerForm.value;

    const providerRequest: IProvider = {
      name: formValue.name?.trim() || '',
      professional_council: formValue.professionalCouncil?.trim() || '',
      profession: formValue.profession?.trim() || '',
      professional_registration: formValue.professionalRegistration?.trim() || ''
    };

    this.providerService.updateProvider(this.providerId, providerRequest)
      .subscribe({
        next: () => {
          this.loading = false;
          this.router.navigateByUrl('/main/v2', { skipLocationChange: true }).then(() => {
            this.router.navigate(['main', 'v2', 'providers']);
          });
        },
        error: (error) => {
          console.error('Erro ao atualizar prestador:', error);
          this.loading = false;
        }
      });
  }
}
